import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, mergeProps as _mergeProps } from "vue"

import { ref, onMounted, watch, computed } from 'vue'
import { debounce, differenceBy, uniqBy } from 'lodash-es'
import CosInputView from '@/components/Antd/CosView/input.vue'
import { useI18n } from 'vue-i18n'
import { getLbuRoadAreaSelectList } from '@/api/yuntuSales/roadAreaCode'

export default /*#__PURE__*/_defineComponent({
  __name: 'roadAreaSelect',
  props: {
  value: {
    type: [String, Number, Array]
  },
  initParams: {
    type: Object,
    default: () => {
      return {}
    }
  },
  placeholder: {
    type: String
  },
  view: {
    type: Boolean
  },
  mode: {
    type: String
  },
  defaultValue: {
    type: String
  },
  // 是否根据登录员工的数据权限查询，默认是false
  permission: {
    type: Boolean,
    default: false
  },
  // 单选时返回的字段：'roadAreaCode' 或 'roadAreaUserList'（默认）
  update: {
    type: String,
    default: 'roadAreaUserList'
  }
},
  emits: ['update:value', 'change', 'onSelect'],
  setup(__props, { expose: __expose, emit: __emit }) {

const { t } = useI18n()

const props = __props
const data = ref()
const roadAreaSelect = ref()
const emit = __emit
const optionPage = ref<any[]>([])
const pageNumber = ref(1)
const searchTxt = ref('')
const valueList = ref<any[]>([])
const change = (value: any) => {
  console.log(value)
  if (props.mode === 'multiple') {
    // 多选模式：返回 roadAreaCode 列表
    emit('update:value', value)
    emit('change', value)
    const records = optionPageComputed.value.filter((item: any) => value.includes(item.roadAreaCode))
    emit('onSelect', records)
  } else {
    // 单选模式：根据 update 属性返回 roadAreaCode 或 roadAreaUserList
    const record = optionPage.value.find((v: any) => v.roadAreaCode === value)
    if (props.update === 'roadAreaCode') {
      emit('update:value', value)
    } else {
      emit('update:value', record?.roadAreaUserList)
    }
    emit('change', value)
    emit('onSelect', record)
  }
}
const popupScroll = (e: any) => {
  const { scrollHeight, scrollTop, clientHeight } = e.target
  if (scrollHeight - scrollTop === clientHeight) {
    pageNumber.value = pageNumber.value + 1
    fetch()
  }
}
const optionPageComputed = computed(() => {
  if (searchTxt.value) {
    return optionPage.value
  }
  return uniqBy([...valueList.value, ...optionPage.value], 'roadAreaCode')
})
// 是否请求接口获取值对应的详细信息
const needFetchValue = (v: any[]) => {
  if (v && v.length) {
    const vL = v.map((code) => {
      return {
        roadAreaCode: code
      }
    })
    const valueArr = differenceBy(vL, optionPage.value, 'roadAreaCode')
    if (valueArr && valueArr.length) {
      // 这里可以根据实际情况调用接口获取详细信息
      // 如果没有对应接口，valueList 保持为空即可
      valueList.value = valueArr
    }
  }
}
// 显示文本
const viewTxt = computed(() => {
  console.log('One:', props.value)
  if (optionPageComputed.value && props.value) {
    if (props.mode === 'multiple') {
      // 多选模式：props.value 是 roadAreaCode 数组
      if (Array.isArray(props.value)) {
        const result: any = []
        props.value.forEach((val) => {
          const find = optionPageComputed.value.find((item) => item.roadAreaCode === val)
          if (find) {
            result.push(find.roadAreaCode)
          } else {
            result.push(val)
          }
        })
        return result.join(';') || '--'
      }
      return props.value || '--'
    } else {
      // 单选模式：根据 update 属性判断 props.value 的类型
      if (props.update === 'roadAreaCode') {
        // props.value 是 roadAreaCode
        const find = optionPageComputed.value.find((item) => item.roadAreaCode === props.value)
        if (find) {
          return find.roadAreaCode
        }
        return props.value || '--'
      } else {
        // props.value 是 roadAreaUserList（数组）
        if (Array.isArray(props.value)) {
          // 通过 roadAreaUserList 查找对应的 roadAreaCode
          const find = optionPageComputed.value.find((item) =>
            JSON.stringify(item.roadAreaUserList) === JSON.stringify(props.value)
          )
          if (find) {
            return find.roadAreaCode
          }
        }
        return props.value || '--'
      }
    }
  }
  return props.value || '--'
})
const focus = () => {
  roadAreaSelect.value.focus()
}
__expose({
  focus
})
onMounted(() => {
  fetch()
})
const fetchRoadArea = debounce((txt: string) => {
  // 去掉前后空格
  searchTxt.value = txt.trim()
  fetch()
}, 500)
const fetch = () => {
  getLbuRoadAreaSelectList({
    roadAreaCode: searchTxt.value
  }).then((res) => {
    optionPage.value = res.data || []
  })
}
watch(
  () => props.value,
  (v) => {
    if (!v) {
      data.value = v
      // 处理搜索
      if (searchTxt.value) {
        fetchRoadArea('')
      }
    } else if (Array.isArray(v)) {
      if (props.mode === 'multiple') {
        // 多选模式：v 是 roadAreaCode 数组
        if (JSON.stringify(v) !== JSON.stringify(data.value)) {
          data.value = v
          needFetchValue(v)
        }
      } else {
        // 单选模式：根据 update 属性判断 v 的类型
        if (props.update === 'roadAreaCode') {
          // v 是 roadAreaCode
          if (v !== data.value) {
            data.value = v
          }
        } else {
          // v 是 roadAreaUserList，需要找到对应的 roadAreaCode 来设置 data.value
          const find = optionPageComputed.value.find((item) =>
            JSON.stringify(item.roadAreaUserList) === JSON.stringify(v)
          )
          if (find && find.roadAreaCode !== data.value) {
            data.value = find.roadAreaCode
          }
        }
      }
    } else if (typeof v === 'string' && v !== data.value) {
      data.value = v
      needFetchValue([v])
    }
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!

  return (__props.view)
    ? (_openBlock(), _createBlock(CosInputView, {
        key: 0,
        mode: __props.mode,
        value: viewTxt.value
      }, null, 8, ["mode", "value"]))
    : (_openBlock(), _createBlock(_component_a_select, _mergeProps({ key: 1 }, _ctx.$attrs, {
        value: data.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((data).value = $event)),
        mode: __props.mode,
        style: {"width":"100%"},
        ref_key: "roadAreaSelect",
        ref: roadAreaSelect,
        onChange: change,
        allowClear: "",
        onPopupScroll: popupScroll,
        showSearch: true,
        "filter-option": false,
        onSearch: _unref(fetchRoadArea),
        placeholder: __props.placeholder || _unref(t)('common.pleaseSelect')
      }), {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionPageComputed.value, (item) => {
            return (_openBlock(), _createBlock(_component_a_select_option, {
              key: item.roadAreaCode,
              value: item.roadAreaCode
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.roadAreaCode), 1)
              ]),
              _: 2
            }, 1032, ["value"]))
          }), 128))
        ]),
        _: 1
      }, 16, ["value", "mode", "onSearch", "placeholder"]))
}
}

})